module.exports = __webpack_public_path__ + "static/media/banner_como_funciona.c3e3980e.jpg";